import { initializeApp } from "firebase/app";
import { getStorage, ref, getDownloadURL, uploadBytes } from "firebase/storage";
import { getAuth } from "firebase/auth";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from "firebase/app-check";
import { getUUID } from "../functions/functions";

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_STORAGE_apiKey,
  authDomain: process.env.REACT_APP_STORAGE_authDomain,
  projectId: process.env.REACT_APP_STORAGE_projectId,
  storageBucket: process.env.REACT_APP_STORAGE_storageBucket,
  messagingSenderId: process.env.REACT_APP_STORAGE_messagingSenderId,
  appId: process.env.REACT_APP_STORAGE_appId,
};

let firebaseApp;
export const firebaseInitializeApp = () => {
  if (!firebaseApp) {
    firebaseApp = initializeApp(firebaseConfig);
  }

  initializeAppCheck(firebaseApp, {
    provider: new ReCaptchaEnterpriseProvider(
      process.env.REACT_APP_STORAGE_reCAPTCHA
    ),
    isTokenAutoRefreshEnabled: true,
  });
  return firebaseApp;
};

let firebaseAuth;
export const firebaseGetAuth = () => {
  firebaseApp = firebaseInitializeApp();
  if (!firebaseAuth) {
    firebaseAuth = getAuth(firebaseApp);
  }
  return firebaseAuth;
};

let firebaseStorage;
export const firebaseGetStorage = () => {
  firebaseApp = firebaseInitializeApp();
  if (!firebaseStorage) {
    firebaseStorage = getStorage(
      firebaseApp,
      process.env.REACT_APP_STORAGE_bucketUrl
    );
  }
  return firebaseStorage;
};

export const firebaseGetFileUrl = async ({ filePath }) => {
  try {
    const storage = firebaseGetStorage();
    const fileRef = ref(storage, filePath);
    const url = await getDownloadURL(fileRef);
    return url;
  } catch (error) {
    console.error(error);
  }
};

export const uploadImage = async (FileObject, folderPath = "") => {
  if (!FileObject) throw new Error("No file provided for upload.");
  try {
    const firebaseAuth = firebaseGetAuth();
    const user = firebaseAuth.currentUser;
    if (!user) {
      throw new Error("Firebase user is not authenticated.");
    }

    const extension = FileObject.type.split("/")[1];
    let filePath = `${folderPath}/${getUUID()}.${extension}`;

    const firebaseStorage = firebaseGetStorage();

    const storageRef = ref(firebaseStorage, filePath);

    const snapshot = await uploadBytes(storageRef, FileObject);

    const url = await getDownloadURL(snapshot.ref);

    return { url, filePath };
  } catch (err) {
    console.error("Error during compression or upload:", err);
    throw err;
  }
};

function base64ToBlob(base64, mimeType = "image/jpeg") {
  const byteString = atob(base64.split(",")[1] || base64);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeType });
}

export const uploadImageBase64 = async (base64String, folderPath = "") => {
  if (!base64String) throw new Error("No base64 string provided.");

  try {
    const firebaseAuth = firebaseGetAuth();
    const user = firebaseAuth.currentUser;
    if (!user) throw new Error("Firebase user is not authenticated.");

    const mimeMatch = base64String.match(/^data:(.+);base64,/);
    const mimeType = mimeMatch ? mimeMatch[1] : "image/jpeg";
    const extension = mimeType.split("/")[1];

    const filePath = `${folderPath}/${getUUID()}.${extension}`;
    const firebaseStorage = firebaseGetStorage();
    const storageRef = ref(firebaseStorage, filePath);

    const blob = base64ToBlob(base64String, mimeType);
    const snapshot = await uploadBytes(storageRef, blob);
    const url = await getDownloadURL(snapshot.ref);

    return { url, filePath };
  } catch (err) {
    console.error("Error during upload:", err);
    throw err;
  }
};
